<template>
  <BannerMenu />
  <Intro />
  <Servicos />
  <Avisoscomunicados />
  <Bolsasdeestudo />
  <Noticias />
  <EmentaHome />
  <FAQ />
  <LinksBar />
</template>

<script>
import BannerMenu from "@/components/BannerMenu.vue";
import Intro from "@/containers/home/intro.vue";
import Servicos from "@/containers/home/servicos.vue";
import Avisoscomunicados from "@/containers/home/avisoscomunicados.vue";
import Bolsasdeestudo from "@/containers/home/bolsasdeestudo.vue";
import Noticias from "@/containers/home/noticias.vue";
import EmentaHome from "@/containers/home/ementahome.vue";
import FAQ from "@/containers/home/faq.vue"; 
import LinksBar from "@/containers/home/linksbar.vue"; 

export default {
  components:{
    BannerMenu,
    Intro,
    Servicos,
    Avisoscomunicados,
    Bolsasdeestudo,
    Noticias,
    EmentaHome,
    FAQ,
    LinksBar
  },
  setup(){


    

    /*var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.remove("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.remove("padding");*/
  }
}
</script>